"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _max2 = _interopRequireDefault(require("lodash/max"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _generateLabelsForm = _interopRequireDefault(require("./generateLabelsForm.js"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _builder = _interopRequireDefault(require("./builder.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/jsx-indent-props, react/jsx-closing-bracket-location */
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getNewLabelId", function () {
      return ((0, _max2["default"])(_this.props.fields.labels.map(function (label) {
        return label.id.value;
      })) || 0) + 1;
    });
    _defineProperty(_assertThisInitialized(_this), "_addLabel", function (event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.fields.labels.addField({
        id: _this._getNewLabelId(),
        value: _this.props.fields.min.value,
        name: _this._getDefaultLabelName(),
        position: 'center',
        verticalPosition: 'bottom'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getDefaultLabelName", function () {
      return 'Label';
    });
    _defineProperty(_assertThisInitialized(_this), "_deleteLabel", function (index, event) {
      if (event) {
        event.preventDefault();
      }
      _this.props.fields.labels.removeField(index);
    });
    _defineProperty(_assertThisInitialized(_this), "_generateLabels", function (numbers, verticalPosition) {
      var labels = _this.props.fields.labels;
      var nextId = _this._getNewLabelId();

      // Remove old labels
      for (var i = labels.length - 1; i >= 0; i--) {
        if (labels[i].verticalPosition.value === verticalPosition) {
          labels.removeField(i);
        }
      }

      // Add new labels
      (0, _forEach2["default"])(numbers, function (number) {
        labels.addField({
          id: nextId++,
          value: number.toString(),
          name: number.toString(),
          position: 'center',
          verticalPosition: verticalPosition
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_sortLabelsByValue", function (event) {
      if (event) {
        event.preventDefault();
      }
      var labels = _this.props.fields.labels;
      var cloneLabels = (0, _sortBy2["default"])((0, _cloneDeep2["default"])(labels), function (label) {
        return +label.value.value;
      });
      var nextId = _this._getNewLabelId();

      // Remove old labels
      for (var i = labels.length - 1; i >= 0; i--) {
        labels.removeField(i);
      }

      // Add new labels
      cloneLabels.forEach(function (label) {
        labels.addField({
          id: nextId++,
          value: label.value.value,
          name: label.name.value,
          position: label.position.value,
          verticalPosition: label.verticalPosition.value
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderLabel", function (label, labelField) {
      return /*#__PURE__*/_react["default"].createElement("div", null, labelField);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderLimits", function () {
      var _this$props$fields = _this.props.fields,
        min = _this$props$fields.min,
        max = _this$props$fields.max,
        defaultValue = _this$props$fields.defaultValue,
        isLimitsExpanded = _this$props$fields.isLimitsExpanded,
        defaultValueVariable = _this$props$fields.defaultValueVariable;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Limits",
        type: _this.props.formBlockType,
        show: isLimitsExpanded.value,
        handleClick: function handleClick(show) {
          return isLimitsExpanded.onChange(show);
        },
        isError: (0, _cccisdSurveyCommon.checkForErrors)([min, max, defaultValue])
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'row ' + _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: min,
        label: "Min"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: max,
        label: "Max"
      })), (!defaultValueVariable || !defaultValueVariable.value) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: defaultValue,
        label: "Default value"
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderValidation", function () {
      var _this$props$fields2 = _this.props.fields,
        isAnswerRequired = _this$props$fields2.isAnswerRequired,
        noAnswerMessage = _this$props$fields2.noAnswerMessage,
        isValidationExpanded = _this$props$fields2.isValidationExpanded;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Required",
        type: _this.props.formBlockType,
        show: isValidationExpanded.value,
        handleClick: function handleClick(show) {
          return isValidationExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: !isAnswerRequired.value ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isAnswerRequired))), " Require an answer"))), isAnswerRequired.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: noAnswerMessage,
        label: "No answer error message"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderLabels", function () {
      var _this$props$fields3 = _this.props.fields,
        min = _this$props$fields3.min,
        max = _this$props$fields3.max,
        labels = _this$props$fields3.labels,
        isLabelsExpanded = _this$props$fields3.isLabelsExpanded;
      var generateLabelsTooptip;
      if (!min.valid || !max.valid) {
        generateLabelsTooptip = 'There are some errors in the min/max values';
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Labels ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, labels.length)),
        type: _this.props.formBlockType,
        show: isLabelsExpanded.value,
        handleClick: function handleClick(show) {
          return isLabelsExpanded.onChange(show);
        },
        isError: (0, _cccisdSurveyCommon.checkForErrors)([labels])
      }, labels.map(function (label, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: label.id.value
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _builder["default"].labels + ' ' + _common["default"].lastRow
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _builder["default"].value
        }, index === 0 && /*#__PURE__*/_react["default"].createElement("label", {
          className: "control-label"
        }, "Value"), /*#__PURE__*/_react["default"].createElement("div", {
          className: 'form-group form-group-sm ' + (label.value.error && 'has-error')
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "text"
        }, (0, _domOnlyProps["default"])(label.value), {
          className: "form-control"
        })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
          field: label.name,
          label: index === 0 ? 'Label' : null,
          isWysiwyg: true,
          wysiwygProps: {
            selectAllOnFocus: label.name.value === _this._getDefaultLabelName()
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _builder["default"].verticalPosition
        }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
          field: label.verticalPosition,
          label: index === 0 ? 'Place' : null
        }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(label.verticalPosition), {
          className: "form-control"
        }), /*#__PURE__*/_react["default"].createElement("option", {
          value: "top"
        }, "Top"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "bottom"
        }, "Bottom")))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _builder["default"].position
        }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
          field: label.position,
          label: index === 0 ? 'Alignment' : null
        }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(label.position), {
          className: "form-control"
        }), /*#__PURE__*/_react["default"].createElement("option", {
          value: "left"
        }, "Left"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "center"
        }, "Center"), /*#__PURE__*/_react["default"].createElement("option", {
          value: "right"
        }, "Right")))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _builder["default"].actions,
          style: index === 0 ? {
            paddingTop: '24px'
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          title: "Delete label",
          onClick: function onClick(event) {
            return _this._deleteLabel(index, event);
          }
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "glyphicon glyphicon-remove text-danger"
        })))), label.value.error && /*#__PURE__*/_react["default"].createElement("div", {
          className: "has-error"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "help-block"
        }, label.value.error)));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _builder["default"].buttonWrapper
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-sm btn-default",
        onClick: _this._addLabel
      }, "Add label"), ' ', generateLabelsTooptip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: generateLabelsTooptip,
        type: "error",
        size: "medium"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default btn-sm",
        disabled: true
      }, "Generate labels")) : /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-default btn-sm"
        }, "Generate labels"),
        title: "Generate labels",
        formAutoFocus: true
      }, /*#__PURE__*/_react["default"].createElement(_generateLabelsForm["default"], {
        min: +min.value,
        max: +max.value,
        initialValues: {
          gap: Math.pow(10, Math.floor((max.value - min.value) / 3).toString().length - 1),
          verticalPosition: 'bottom'
        },
        generateLabels: _this._generateLabels
      })), ' ', /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default btn-sm",
        onClick: _this._sortLabelsByValue
      }, "Sort by value")));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderOthers", function () {
      var _this$props$fields4 = _this.props.fields,
        snapToLabels = _this$props$fields4.snapToLabels,
        maxWidth = _this$props$fields4.maxWidth,
        showNumberWhenDragging = _this$props$fields4.showNumberWhenDragging,
        isOthersExpanded = _this$props$fields4.isOthersExpanded;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Formatting",
        type: _this.props.formBlockType,
        show: isOthersExpanded.value,
        handleClick: function handleClick(show) {
          return isOthersExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxWidth,
        label: "Max width",
        comment: "e.g. 100% or 200px"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(snapToLabels))), " Snap to label when dragging slider")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showNumberWhenDragging))), " Show number when dragging slider")));
    });
    return _this;
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields5 = this.props.fields,
        question = _this$props$fields5.question,
        description = _this$props$fields5.description;
      return /*#__PURE__*/_react["default"].createElement("div", null, !this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        type: "textarea-inline",
        onChange: question.onChange,
        selectAllOnFocus: question.value === _settings.initialValues.question
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        type: "textarea-inline",
        onChange: description.onChange
      }))), this._renderLimits(), this._renderLabels(), this._renderValidation(), this._renderOthers());
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  formBlockType: _propTypes["default"].string,
  labelsConstant: _propTypes["default"].string,
  isMatrixMode: _propTypes["default"].bool,
  valid: _propTypes["default"].bool
});
_defineProperty(Builder, "defaultProps", {
  formBlockType: 'primary',
  labelsConstant: 'LABEL',
  isMatrixMode: false
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withQuestionNumbers: true,
  withDefaultValueFromVariable: true,
  withVisibilityConditions: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true
})(Builder);